import { render, staticRenderFns } from "./ClientUnitHistory.vue?vue&type=template&id=53be1218&scoped=true"
import script from "./ClientUnitHistory.vue?vue&type=script&lang=js"
export * from "./ClientUnitHistory.vue?vue&type=script&lang=js"
import style0 from "./ClientUnitHistory.vue?vue&type=style&index=0&id=53be1218&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be1218",
  null
  
)

export default component.exports